
import React from 'react';

const ProcessSection = () => {
  const steps = [
    {
      number: '01',
      title: 'Comprehensive Assessment',
      description: 'Detailed health evaluation including medical history, current symptoms, and specific goals to determine the best peptide protocols for your needs.',
      icon: 'ri-file-list-3-line'
    },
    {
      number: '02',
      title: 'Advanced Laboratory Testing',
      description: 'Comprehensive blood work and biomarker analysis to establish baseline levels and identify optimal peptide combinations for your unique physiology.',
      icon: 'ri-test-tube-line'
    },
    {
      number: '03',
      title: 'Custom Protocol Design',
      description: 'Our experts create a personalized peptide regimen tailored to your specific health goals, combining multiple peptides for synergistic effects.',
      icon: 'ri-settings-3-line'
    },
    {
      number: '04',
      title: 'Treatment Initiation',
      description: 'Begin your peptide therapy with proper injection training, dosing guidelines, and comprehensive support from our medical team.',
      icon: 'ri-syringe-line'
    },
    {
      number: '05',
      title: 'Progress Monitoring',
      description: 'Regular check-ins and follow-up testing to track your progress, adjust dosages, and optimize your peptide protocol for maximum benefits.',
      icon: 'ri-line-chart-line'
    },
    {
      number: '06',
      title: 'Ongoing Optimization',
      description: 'Continuous refinement of your peptide therapy based on results, with the flexibility to add new peptides or modify protocols as needed.',
      icon: 'ri-refresh-line'
    }
  ];

  return (
    <section className="py-16 lg:py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12 lg:mb-16">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-900 mb-4 lg:mb-6">
            Your <strong>Peptide Therapy</strong> Journey
          </h2>
          <p className="text-lg sm:text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Our systematic approach ensures you receive the most effective peptide protocols tailored to your unique health profile and goals.
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-8 lg:gap-12">
          {steps.map((step, index) => (
            <div key={index} className="flex items-start space-x-4 lg:space-x-6">
              <div className="flex-shrink-0">
                <div className="w-16 h-16 bg-gradient-to-r from-blue-600 to-blue-700 rounded-2xl flex items-center justify-center">
                  <i className={`${step.icon} text-2xl text-white`}></i>
                </div>
              </div>
              <div className="flex-1">
                <div className="flex items-center mb-2">
                  <span className="text-sm font-bold text-blue-600 bg-blue-100 px-3 py-1 rounded-full mr-3">
                    {step.number}
                  </span>
                  <h3 className="text-xl lg:text-2xl font-bold text-gray-900">
                    {step.title}
                  </h3>
                </div>
                <p className="text-gray-600 leading-relaxed">
                  {step.description}
                </p>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-12 lg:mt-16 bg-white rounded-2xl p-6 lg:p-8 shadow-lg">
          <div className="grid lg:grid-cols-3 gap-6 lg:gap-8 text-center">
            <div>
              <div className="text-2xl lg:text-3xl font-bold text-blue-600 mb-2">2-4 Weeks</div>
              <div className="text-gray-600">Initial Results</div>
            </div>
            <div>
              <div className="text-2xl lg:text-3xl font-bold text-blue-600 mb-2">3-6 Months</div>
              <div className="text-gray-600">Optimal Benefits</div>
            </div>
            <div>
              <div className="text-2xl lg:text-3xl font-bold text-blue-600 mb-2">Ongoing</div>
              <div className="text-gray-600">Continuous Support</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProcessSection;
